import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function NonprofitRelationsPage() {
  return (
    <SoftBox py={3}>
      <SoftTypography variant="h4" fontWeight="bold" gutterBottom>
        Nonprofit Relations (CSV export)
      </SoftTypography>
      <SoftTypography variant="body2" color="text">
        Placeholder view for managing nonprofit relations and CSV exports.
      </SoftTypography>
    </SoftBox>
  );
}

export default NonprofitRelationsPage;


